import { useLikes } from "components/LikesProvider"
import { Heart, HeartRegular } from "components/Icon"

export const LikeIcon = ({ id, ...props }) => {
  const likes = useLikes()
  const isLiked = likes.isLiked(id)

  if (isLiked) {
    return <Heart {...props} />
  }

  return <HeartRegular {...props} />
}
